import { css } from '@emotion/css';
import { Button, Chip } from '@material-ui/core';

export const getBillingStatusChip = (info) => {

  if (!info?.apiSupport) {
    return <Chip classes={{ colorPrimary: css({ background: '#FAE8D7', color: '#FA8100' }) }}
      color="primary"
      label="Statut inconnu"
      size="small" />
  }

  switch (info?.status) {
    case 'TRANSMIS':
      return <Chip classes={{ colorPrimary: css({ background: '#FAE8D7', color: '#FA8100' }) }}
        color="primary"
        label="Transmis"
        size="small" />
    case 'EN_COURS_REGLEMENT':
      return <Chip classes={{ colorPrimary: css({ background: '#FAE8D7', color: '#FA8100' }) }}
        color="primary"
        label="En cours de traitement"
        size="small" />
    case 'REGLE':
      return <Chip classes={{ colorPrimary: css({ background: '#DBFAD8', color: '#008000' }) }}
        color="primary"
        label="Réglé"
        size="small" />
    case 'REFUSE':
    case 'ANNULE':
    case 'BLOQUE':
    case 'RELANCE':
      return <Chip classes={{ colorPrimary: css({ background: '#FBD3D5', color: '#F50057' }) }}
        color="primary"
        label={
          info.status === 'REFUSE' ? 'Refusé' :
            info.status === 'ANNULE' ? 'Annulé' :
              info.status === 'BLOQUE' ? 'Bloqué' :
                info.status === 'RELANCE' ? 'Relance' :
                  'Statut inconnu'
        }
        size="small" />
    default:
      return <Chip classes={{ colorPrimary: css({ background: '#FAE8D7', color: '#FA8100' }) }}
        color="primary"
        label="Aucun statut"
        size="small" />
  }
};

export const getRecordStatusChip = (info) => {
  switch (info?.opcoStatus) {
    case 'READY':
      return (
        <Chip
          classes={{ colorPrimary: css({ background: '#C0D9FF', color: '#0060F9' }) }}

          color="primary"
          label="Contrat prêt"
          size="small"
        />
      );
    case 'TRANSMIS':
    case 'EN_COURS_INSTRUCTION':
    case 'UPLOADING-CERFA':
    case 'UPLOADING-CONTRACT':
    case 'UPLOADING-CONVENTION':
      return (
        <Chip
          classes={{ colorPrimary: css({ background: '#FAE8D7', color: '#FA8100' }) }}
          color="primary"
          label={info.opcoStatus === 'TRANSMIS' ? 'Transmis' :
            ['UPLOADING-CERFA', 'UPLOADING-CONTRACT', 'UPLOADING-CONVENTION'].includes(info.opcoStatus) ? 'En cours de synchronisation' :
              'En cours de traitement'}
          size="small"
        />
      );
    case 'ENGAGE':
      return (
        <Chip
          classes={{ colorPrimary: css({ background: '#DBFAD8', color: '#008000' }) }}
          color="primary"
          label="Engagé"
          size="small"
        />
      );
    case 'FIGE':
    case 'REFUSE':
    case 'ANNULE':
    case 'SOLDE':
    case 'RUPTURE':
    case 'ERROR-CERFA-UPLOAD':
    case 'ERROR-CONTRACT-UPLOAD':
    case 'ERROR-CONVENTION-UPLOAD':
    case 'FORBIDDEN':
    case 'UNSYNC':
      return (
        <Chip
          classes={{ colorPrimary: css({ background: '#FBD3D5', color: '#F50057' }) }}
          color="primary"
          label={
            info.opcoStatus === 'FIGE' ? 'Figé' :
              info.opcoStatus === 'REFUSE' ? 'Refusé' :
                info.opcoStatus === 'ANNULE' ? 'Annulé' :
                  info.opcoStatus === 'SOLDE' ? 'Soldé' :
                    info.opcoStatus === 'RUPTURE' ? 'Rupture' :
                      info.opcoStatus === "FORBIDDEN" ? 'Clé à renouveller' :
                        info.opcoStatus === 'UNSYNC' ? 'Désynchronisé' :
                          'Erreur données'
          }
          size="small"
        />
      );
    default:
      return (
        <Chip
          classes={{ colorPrimary: css({ background: '#FAE8D7', color: '#FA8100' }) }}
          color="primary"
          label="En attente des données"
          size="small"
        />
      );
  }
}

export const getContractStatusChip = (info) => {
  if (info?.opcoStatus == "PENDING") {
    if (info?.contract?.status === "ARCHIVED") {
      return (
        <Chip
          classes={{ colorPrimary: css({ background: '#C0D9FF', color: '#0060F9' }) }}
          color="primary"
          label="Prêt pour OPCO"
          size="small"
        />
      );
    }

    if (info?.contract) {
      let count = 0;
      if (info.contract.cfaSignAction === "SIGNED") count++;
      if (info.contract.businessSignAction === "SIGNED") count++;
      if (info.contract.studentSignAction === "SIGNED") count++;

      if (info.contract.cfaSignAction !== "SIGNED") {
        return (
          <Chip
            classes={{ colorPrimary: css({ background: '#C0D9FF', color: '#0060F9' }) }}
            color="primary"
            label={`Contrat à signer (${count}/3)`}
            size="small"
          />
        );
      }

      return (
        <Chip
          classes={{ colorPrimary: css({ background: '#FAE8D7', color: '#FA8100' }) }}
          color="primary"
          label={`Contrat en cours de signature (${count}/3)`}
          size="small"
        />
      );
    }
  }

  if (info?.billingStepStatus == "REMAINING") {
    return (
      <Chip
        classes={{ colorPrimary: css({ background: '#C0D9FF', color: '#0060F9' }) }}
        color="primary"
        label={'Factures à générer'}
        size="small"
      />
    );
  }

  return getRecordStatusChip(info);

};

export const getTrainingStatusChip = (training) => {
  if (training?.cfaCompliant) {
    return (
      <Chip
        classes={{ colorPrimary: css({ background: '#DBFAD8', color: '#008000' }) }}
        color="primary"
        label="Complète"
        size="small"
      />
    );
  }

  return (
    <Chip
      classes={{ colorPrimary: css({ background: '#FAE8D7', color: '#FA8100' }) }}
      color="primary"
      label="Incomplète"
      size="small"
    />
  );
};